import React from 'react'

const Banner = () => {
    return (
        <div className='bg-blue-950 p-5 flex items-center justify-center flex-col'>
            <h1 className='text-[#fdf651] text-2xl font-semibold'>
                IMPORTANT: Do NOT close this window nor click the “Back” button
            </h1>
            <p className='text-[#fdf651] text-xl'>
                Clicking “back” button can result in your order being double-billed
            </p>

        </div>
    )
}

export default Banner
